__webpack_require__.p = "https://assets.everphone.app/portal/";